import { render, staticRenderFns } from "./DatasetTabTables.vue?vue&type=template&id=ade5dab4&scoped=true&lang=pug"
import script from "./DatasetTabTables.vue?vue&type=script&lang=js"
export * from "./DatasetTabTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade5dab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade5dab4')) {
      api.createRecord('ade5dab4', component.options)
    } else {
      api.reload('ade5dab4', component.options)
    }
    module.hot.accept("./DatasetTabTables.vue?vue&type=template&id=ade5dab4&scoped=true&lang=pug", function () {
      api.rerender('ade5dab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetTabTables.vue"
export default component.exports